// removed by extract-text-webpack-plugin
module.exports = {"container":"_3xV78","cover":"_1MaXL","avatar":"_2w1KF","name":"_3UuFK","date":"_3W86P","stats":"_3kwHv","statsGroup":"_4PC6q","statsNumber":"Ru5-y","statsText":"vucEb","actions":"_2bfuI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/member-list-item/member-list-item-desktop.scss
// module id = 1598
// module chunks = 0